import * as React from 'react';

import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from './components/ui/resizable.js';

export function DimeResizablePanelGroup({
  ...props
}: Readonly<React.ComponentProps<typeof ResizablePanelGroup>>) {
  return <ResizablePanelGroup {...props} />;
}

export function DimeResizablePanel({
  ...props
}: Readonly<React.ComponentProps<typeof ResizablePanel>>) {
  return <ResizablePanel {...props} />;
}

export function DimeResizableHandle({
  ...props
}: Readonly<React.ComponentProps<typeof ResizableHandle>>) {
  return <ResizableHandle {...props} />;
}
